/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentSocialUploadsByFragmentIdQueryResponse, GetFragmentSocialUploadsByFragmentIdPathParams } from "../models/GetFragmentSocialUploadsByFragmentId";

export function getGetFragmentSocialUploadsByFragmentIdUrl(fragmentId: GetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"]) {
  const res = { method: 'GET', url: `/fragment-social-uploads/by-fragment/${fragmentId}` as const }
  return res
}

/**
 * @summary Get social uploads for a fragment
 * {@link /fragment-social-uploads/by-fragment/:fragmentId}
 */
export async function getFragmentSocialUploadsByFragmentId(fragmentId: GetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetFragmentSocialUploadsByFragmentIdUrl(fragmentId).url.toString(), ... requestConfig })
  return res.data
}